import * as yup from 'yup';

export const paymentTerminalSchema = yup.object({
  description: yup.string().required(),
  terminalId: yup.number().min(10000000).max(99999999).required(),
  stationId: yup.string().required(),
  userIds: yup.array(yup.string()).optional(),
});
